import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';
import { toCurrencyFormat } from '@/core/helpers/GlobalHelpers';
import type { Props as IconProps } from '@/core/components/base/image/SvgThemedIcon.vue';

export interface Balance {
    amount: number,
    icon: IconProps,
    symbol: string,
    skeleton?: boolean,
    loading?: boolean,
}

interface Props {
    direction?: 'column' | 'row',
    balances: Balance[],
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultipleAssetAmounts',
  props: {
    direction: { default: 'row' },
    balances: { default: () => [] as Balance[] }
  },
  setup(__props: any) {

const props = __props as { direction: 'column' | 'row', balances: Balance[] };



const {
    direction,
    balances,
} = toRefs(props);


return { __sfc: true,props, direction, balances, toCurrencyFormat }
}

})